module.exports = __webpack_public_path__ + "static/img/1.d7c96ab6.png";